import React from "react";
import { Box, Button, Card, CardContent, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const FeeCard = ({ title, description, to }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <Card variant="outlined" sx={{ height: "100%" }}>
      <CardContent sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
        <Typography variant="h6" fontWeight="bold">
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
        <Box sx={{ mt: "auto" }}>
          <Button variant="contained" onClick={() => navigate(to)}>
            {t("finance.open", { defaultValue: "Open" })}
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

const FeesCollection = () => {
  const { t } = useTranslation();

  const items = [
    {
      title: t("finance.patientTicketCollection", { defaultValue: "Ticket / OPD Collection" }),
      description: t("finance.patientTicketCollectionDesc", { defaultValue: "Collect and print patient ticket dues." }),
      to: "/finance/payment-collection",
    },
    {
      title: t("finance.purchasePayments", { defaultValue: "Purchase / POS Payments" }),
      description: t("finance.purchasePaymentsDesc", { defaultValue: "Collect medicine purchase and POS payments." }),
      to: "/finance/medicine-payment",
    },
    {
      title: t("finance.dentalFees", { defaultValue: "Dental Fees" }),
      description: t("finance.dentalFeesDesc", { defaultValue: "Collect dental procedure fees." }),
      to: "/finance/fees-collection/dental",
    },
    {
      title: t("finance.beautyFees", { defaultValue: "Beauty Fees" }),
      description: t("finance.beautyFeesDesc", { defaultValue: "Collect beauty procedure fees." }),
      to: "/finance/fees-collection/beauty",
    },
    {
      title: t("finance.htPatientFees", { defaultValue: "HT Patient Fees" }),
      description: t("finance.htPatientFeesDesc", { defaultValue: "Collect HT patient fees." }),
      to: "/finance/fees-collection/ht-patient",
    },
    {
      title: t("finance.laboratoryFees", { defaultValue: "Laboratory Fees" }),
      description: t("finance.laboratoryFeesDesc", { defaultValue: "Collect lab fees and pending balances." }),
      to: "/finance/fees-collection/laboratory",
    },
    {
      title: t("finance.xrayFees", { defaultValue: "X-Ray Fees" }),
      description: t("finance.xrayFeesDesc", { defaultValue: "Collect x-ray fees." }),
      to: "/finance/fees-collection/xray",
    },
    {
      title: t("finance.ultrasoundFees", { defaultValue: "Ultrasound Fees" }),
      description: t("finance.ultrasoundFeesDesc", { defaultValue: "Collect ultrasound fees." }),
      to: "/finance/fees-collection/ultrasound",
    },
    {
      title: t("finance.echoFees", { defaultValue: "Echo Fees" }),
      description: t("finance.echoFeesDesc", { defaultValue: "Collect echocardiography fees." }),
      to: "/finance/fees-collection/echo",
    },
    {
      title: t("finance.emergencyFees", { defaultValue: "Emergency Fees" }),
      description: t("finance.emergencyFeesDesc", { defaultValue: "Collect emergency visit fees." }),
      to: "/finance/fees-collection/emergency",
    },
    {
      title: t("finance.ipdFees", { defaultValue: "IPD Fees" }),
      description: t("finance.ipdFeesDesc", { defaultValue: "Collect inpatient department fees." }),
      to: "/finance/fees-collection/ipd",
    },
    {
      title: t("finance.icuFees", { defaultValue: "ICU Fees" }),
      description: t("finance.icuFeesDesc", { defaultValue: "Collect ICU fees." }),
      to: "/finance/fees-collection/icu",
    },
    {
      title: t("finance.nicuFees", { defaultValue: "NICU Fees" }),
      description: t("finance.nicuFeesDesc", { defaultValue: "Collect NICU baby fees." }),
      to: "/finance/fees-collection/nicu",
    },
    {
      title: t("finance.ambulanceFees", { defaultValue: "Ambulance Fees" }),
      description: t("finance.ambulanceFeesDesc", { defaultValue: "Collect ambulance service fees and driver payments." }),
      to: "/finance/fees-collection/ambulance",
    },
  ];

  return (
    <Box sx={{ p: 3, width: "100%" }}>
      <Typography variant="h5" fontWeight="bold" sx={{ mb: 1 }}>
        {t("finance.feesCollection", { defaultValue: "Fees Collection" })}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        {t("finance.feesCollectionDesc", {
          defaultValue: "All patient and purchase payment collection is managed here.",
        })}
      </Typography>
      <Grid container spacing={2}>
        {items.map((item) => (
          <Grid item xs={12} sm={6} lg={4} key={item.to}>
            <FeeCard {...item} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default FeesCollection;
